///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const HelpIcon = ({
  height,
  fill = "#0066FA",
  title = messages.help.defaultMessage,
  width,
  ...props
}) => (
  <svg
    aria-labelledby="help-icon"
    height={height}
    width={width}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title id="help-icon">{title}</title>
    <g clipPath="url(#help)">
      <path
        fill={fill}
        d="M20 3.333C10.8 3.333 3.335 10.8 3.335 20c0 9.2 7.467 16.667 16.667 16.667 9.2 0 16.666-7.467 16.666-16.667 0-9.2-7.466-16.667-16.666-16.667Zm1.667 28.334h-3.333v-3.334h3.333v3.334Zm3.45-12.917-1.5 1.533c-1.2 1.217-1.95 2.217-1.95 4.717h-3.333v-.833c0-1.834.75-3.5 1.95-4.717l2.067-2.1c.616-.6.983-1.433.983-2.35 0-1.833-1.5-3.333-3.333-3.333A3.343 3.343 0 0 0 16.667 15h-3.333a6.665 6.665 0 0 1 6.667-6.667A6.665 6.665 0 0 1 26.667 15c0 1.467-.6 2.8-1.55 3.75Z"
      />
    </g>
    <defs>
      <clipPath id="help">
        <path fill="#fff" d="M0 0h40v40H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default HelpIcon;
